import { render, staticRenderFns } from "./EditInsuredInformationsModal.vue?vue&type=template&id=456459a1&scoped=true&"
import script from "./EditInsuredInformationsModal.vue?vue&type=script&lang=js&"
export * from "./EditInsuredInformationsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditInsuredInformationsModal.vue?vue&type=style&index=0&id=456459a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456459a1",
  null
  
)

export default component.exports